import { connect } from 'react-redux';
import { get } from 'lodash';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import { loading, loadingSuccess } from '@actions/loading';
import { showErrorMessage } from '@actions/messageconfirmation';

import { ENUM_MODULE_NAME } from '@commons/utils/features';
import { isUserManager } from '@commons/utils/roles';
import NavigationBar from '@commons/NavigationBar';

import { product as productService } from '@services/product';

import ProductExternalClients from '@admin/products/products/detail/components/ProductExternalClients';

import { ContentContainer } from './styledComponents';

/**
 * Central kitchen product detail — "Catalogues B2B" tab
 * (/admin/kitchen-products/products/:id/b2b-catalogs): external clients having the central
 * product in their catalog, restricted to the central kitchen stores.
 */
const KitchenProductB2bCatalogs = (props) => {
  const { match, user, pageLoading, pageLoaded, showErrorMessage } = props;

  const path = get(match, 'path');
  const params = get(match, 'params');

  const [productId] = useState(params.id);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    pageLoading();

    (async () => {
      try {
        const fetchedProduct = await productService.getById(productId);

        setProduct(fetchedProduct);
      } catch {
        showErrorMessage(i18next.t('GENERAL.GLOBAL_FETCH_ERROR'));
      } finally {
        pageLoaded();
      }
    })();
  }, [productId]);

  const isReadOnly = isUserManager(user) || (!!product && !product.active);

  return (
    <>
      <NavigationBar
        module={ENUM_MODULE_NAME.KITCHEN_PRODUCT_DETAILS}
        path={path}
        product={{ name: product?.name ?? '', id: productId }}
        bigTopBar
        displaySubFeatures
        enableActionBottomOrder
      />
      <ContentContainer>
        {product && (
          <ProductExternalClients isReadOnly={isReadOnly} product={product} isKitchenProduct />
        )}
      </ContentContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.baseReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  pageLoading: () => {
    dispatch(loading());
  },
  pageLoaded: () => {
    dispatch(loadingSuccess());
  },
  showErrorMessage: (message) => {
    dispatch(showErrorMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitchenProductB2bCatalogs);
